import {LocaleStatus} from "@khan/i18n";

const {BEGINNING, LITE, TEST, LIVE, ROCK_STAR} = LocaleStatus;

const _LANGUAGES = {
    // sync-start:locales 1602711686 https://github.com/Khan/webapp/blob/master/pkg/services_shared/intl/ka_locales.go
    am: BEGINNING, // Amharic
    mk: BEGINNING, // Macedonian
    ps: BEGINNING, // Pashto
    sl: BEGINNING, // Slovenian
    so: BEGINNING, // Somali
    sq: BEGINNING, // Albanian

    ar: LITE, // Arabic
    "fa-af": LITE, // Dari
    he: LITE, // Hebrew
    ms: LITE, // Malay
    fa: LITE, // Persian
    sw: LITE, // Swahili
    th: LITE, // Thai
    xh: LITE, // Xhosa
    zu: LITE, // Zulu

    accents: TEST, // Fake language for testing possible css issues
    as: TEST, // Assamese
    az: TEST, // Azerbaijani
    boxes: TEST, // Fake language for testing marked for translation
    cs: TEST, // Czech
    da: TEST, // Danish
    el: TEST, // Greek
    "en-pt": TEST, // The pseudo-language needed for Crowdin JIPT
    "en-x-rtl": TEST, // Pseudo locale for testing rtl locales
    fv: TEST, // Fulfulde Mbororoore
    gu: TEST, // Gujarati
    hu: TEST, // Hungarian
    id: TEST, // Indonesian
    is: TEST, // Icelandic
    it: TEST, // Italian
    ja: TEST, // Japanese
    kk: TEST, // Kazakh
    kn: TEST, // Kannada
    ky: TEST, // Kyrgyz
    lol: TEST, // LOLCAT (a testing sandbox)
    lt: TEST, // Lithuanian
    lv: TEST, // Latvian
    mn: TEST, // Mongolian
    mr: TEST, // Marathi
    my: TEST, // Burmese
    nl: TEST, // Dutch
    "pt-pt": TEST, // Portuguese (Portugal)
    ru: TEST, // Russian
    rw: TEST, // Kinyarwanda
    "sgn-us": TEST, // American Sign Language
    sk: TEST, // Slovak
    sv: TEST, // Swedish
    ta: TEST, // Tamil
    uz: TEST, // Uzbek
    "zh-hant": TEST, // Chinese traditional (Taiwan/Hong Kong)

    bg: LIVE, // Bulgarian
    bn: LIVE, // Bengali
    de: LIVE, // German
    fr: LIVE, // French
    hi: LIVE, // Hindi
    hy: LIVE, // Armenian
    ka: LIVE, // Georgian
    km: LIVE, // Khmer
    ko: LIVE, // Korean
    nb: LIVE, // Norwegian Bokmal
    or: LIVE, // Odia
    pa: LIVE, // Punjabi
    pl: LIVE, // Polish
    pt: LIVE, // Portugese (Brazilian)
    ro: LIVE, // Romanian
    sr: LIVE, // Serbian
    te: LIVE, // Telugu
    tr: LIVE, // Turkish
    uk: LIVE, // Ukrainian
    ur: LIVE, // Urdu
    vi: LIVE, // Vietnamese
    "zh-hans": LIVE, // Chinese (Simplified, China mainland)

    es: ROCK_STAR, // Spanish
    // sync-end:locales
} as const;

export const getLocaleStatus = (
    locale: string,
): (typeof LocaleStatus)[keyof typeof LocaleStatus] => {
    return _LANGUAGES[locale];
};

export const getLiveLanguages = (): string[] => {
    return Object.entries(_LANGUAGES)
        .filter(([_, status]) => status === LIVE || status === ROCK_STAR)
        .map(([language]) => language);
};
